import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 0',
    [theme.breakpoints.down(550)]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  value: {
    textAlign: 'right',
    [theme.breakpoints.down(550)]: {
      textAlign: 'center',
      marginTop: 20,
    },
  },
}));
export default useStyles;
